/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import {
  useState,
  useRef,
  useEffect,
  createContext,
  useContext,
  useMemo,
  Fragment as _,
  cloneElement,
  useCallback,
  RefObject,
} from 'react';

export const InputText = ({
  width,
  placeholder = '',
  focusColor = '#000',
  callback = (value: String) => {},
}) => {
  // const {
  //   width,
  //   focusColor = '#000',
  //   callback = (value: String) => {},
  // } = props;

  const [value, setValue] = useState('');
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    callback(value);
  }, [value]);

  return (
    <div
      css={css({
        position: 'relative',
        width,
      })}
    >
      {!hasFocus && (
        <div
          className="data-input-blur-value-display"
          css={css({
            position: 'absolute',
            width,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          })}
        >
          {value}
        </div>
      )}

      <input
        type="text"
        css={css({
          all: 'unset',
          position: 'relative',
          width,
          opacity: !value || hasFocus ? 1 : 0,
          ':focus': {
            all: 'unset',
            width,
            outline: `1px solid ${focusColor}`,
            // boxShadow: `0 0 0 1px ${focusColor}`,
            border: 'transparent !important',
            overflow: 'visible',
          },
        })}
        placeholder={placeholder}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onChange={e => {
          setValue(e.currentTarget.value);
        }}
      />
    </div>
  );
};
